import React from 'react';
import Image from '../../elements/Image';
import styles from './SimpleLayout.module.css';
import moment from 'moment';

const SimpleLayout = ({ children }) => (
  <div className={styles.simpleLayoutContainer}>
    <div className={styles.simpleWrapper}>
      <div className={`${styles.headerbar} d-flex justify-content-center align-items-center`}>
        <a href="/">
          <Image name="simple-logo" className={styles.headerbarImage} />
        </a>
      </div>
      <div>{children}</div>
    </div>
    <div className={`${styles.footerbar}`}>
      <div className={styles.footerinner}>
        <p className={styles.footerMenu}>
          <a target="_blank" href="/tos">
            privacy & terms
          </a>
        </p>
        <p className={styles.copyright}>Copyright © {moment().year()} Smart Funnel Software LLC</p>
      </div>
    </div>
  </div>
);

export default SimpleLayout;
